import type { Reference } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';
import Slider from 'react-slick';

import sharedStyles from '../../styles/styles.scss';

import styles from './CMSRotator.scss';
import CMSRotatorItem from './CMSRotatorItem/CMSRotatorItem';

interface Props {
  items: Reference[];
}

const CMSRotator: React.FC<Props> = ({ items }) => (
  <div className={classNames(styles.cmsRotator, sharedStyles.bgStyle1)}>
    <Slider
      dots
      infinite
      speed={500}
      slidesToShow={1}
      slidesToScroll={1}
      arrows={false}
      autoplay
      autoplaySpeed={5000}
      pauseOnDotsHover
      pauseOnHover={false}
    >
      {items.map((item, key) => (
        <CMSRotatorItem item={item} key={key} />
      ))}
    </Slider>
  </div>
);

export default CMSRotator;
